module.exports = __webpack_public_path__ + "media/v2/components/Blog/shared/img/testArticleImg-974240ba53f6d64e809ad086e22914db.png";